@if (isLoading) {
  <div class="container-loading">
    <app-loader
      [isLoading]="isLoading"
      message="{{ 'Carregando...' }}"
    ></app-loader>
  </div>
}

@if (!isLoading) {
  <div class="toll">
    <div class="toll-body">

      @if (isNotAutorized) {
        <app-notauthorized></app-notauthorized>
      }

      @else {
        <div class="content row edenred-title-page">
          <h1>Selecione abaixo qual portal deseja acessar:</h1>
        </div>

        <main>
          @if (uniqueProfiles.includes(profileType.CUSTOMER)
                || uniqueProfiles.includes(profileType.RELATIONSHIP)) {
            <div class="bnt-div">
              <button
                mat-stroked-button
                class="edenred-btn-large"
                id="btn-customer-profile"
                data-e2e="btn-customer-profile"
                (click)="toEnterCustomerPortal()"
              >
                <img src="assets/icons/people.png" alt=""/>
                <span>Portal do Cliente</span>
              </button>
            </div>
          }

          @if (uniqueProfiles.includes(profileType.PARTNER)) {
            <div class="bnt-div">
              <button
                mat-stroked-button
                class="edenred-btn-large"
                id="btn-partner-profile"
                data-e2e="btn-partner-profile"
                (click)="toEnterPartnerPortal()"
              >
                <img src="assets/icons/security.png" alt=""/>
                <span>Portal do Parceiro</span>
              </button>
            </div>
          }

          @if (!isTokenEdenredConnect) {
            <div class="bnt-div">
              <button
                mat-stroked-button
                class="edenred-btn-large"
                id="btn-backoffice-profile"
                data-e2e="btn-backoffice-profile"
                (click)="toEnterBackOfficePortal()"
              >
                <img src="assets/icons/monitor.png" alt=""/>
                <span>Portal de Atendimento</span>
              </button>
            </div>
          }
        </main>
      }

    </div>

    <div class="toll-footer">
      <app-footer />
    </div>
  </div>
}
